"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LanguageSelector = exports.LANGUAGES = void 0;
require("core-js/modules/es6.string.link.js");
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));
var _get = _interopRequireDefault(require("lodash/get"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _config = require("@nucleo/config");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _reactIntl = require("react-intl");
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/LanguageSelector/lib/index.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2jwyqr2iz1() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/LanguageSelector/lib/index.js";
  var hash = "9d25070d1185bee9464a3f1d045aca6e1898e7ad";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/LanguageSelector/lib/index.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 25
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "1": {
        start: {
          line: 40,
          column: 25
        },
        end: {
          line: 40,
          column: 43
        }
      },
      "2": {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 46,
          column: 33
        }
      },
      "3": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 46,
          column: 33
        }
      },
      "4": {
        start: {
          line: 48,
          column: 23
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "5": {
        start: {
          line: 53,
          column: 27
        },
        end: {
          line: 53,
          column: 51
        }
      },
      "6": {
        start: {
          line: 62,
          column: 25
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "7": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 89
        }
      },
      "8": {
        start: {
          line: 81,
          column: 28
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "9": {
        start: {
          line: 92,
          column: 2
        },
        end: {
          line: 92,
          column: 87
        }
      },
      "10": {
        start: {
          line: 100,
          column: 33
        },
        end: {
          line: 134,
          column: 1
        }
      },
      "11": {
        start: {
          line: 136,
          column: 26
        },
        end: {
          line: 140,
          column: 1
        }
      },
      "12": {
        start: {
          line: 142,
          column: 21
        },
        end: {
          line: 174,
          column: 1
        }
      },
      "13": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 149,
          column: 17
        }
      },
      "14": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 93
        }
      },
      "15": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 160,
          column: 7
        }
      },
      "16": {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 159,
          column: 21
        }
      },
      "17": {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 161,
          column: 55
        }
      },
      "18": {
        start: {
          line: 166,
          column: 18
        },
        end: {
          line: 166,
          column: 66
        }
      },
      "19": {
        start: {
          line: 167,
          column: 18
        },
        end: {
          line: 167,
          column: 48
        }
      },
      "20": {
        start: {
          line: 176,
          column: 24
        },
        end: {
          line: 178,
          column: 1
        }
      },
      "21": {
        start: {
          line: 180,
          column: 30
        },
        end: {
          line: 185,
          column: 1
        }
      },
      "22": {
        start: {
          line: 187,
          column: 17
        },
        end: {
          line: 193,
          column: 1
        }
      },
      "23": {
        start: {
          line: 190,
          column: 14
        },
        end: {
          line: 190,
          column: 52
        }
      },
      "24": {
        start: {
          line: 195,
          column: 37
        },
        end: {
          line: 203,
          column: 1
        }
      },
      "25": {
        start: {
          line: 205,
          column: 17
        },
        end: {
          line: 207,
          column: 1
        }
      },
      "26": {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 211,
          column: 17
        }
      },
      "27": {
        start: {
          line: 212,
          column: 4
        },
        end: {
          line: 215,
          column: 6
        }
      },
      "28": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 216,
          column: 57
        }
      },
      "29": {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 217,
          column: 73
        }
      },
      "30": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 221,
          column: 67
        }
      },
      "31": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 70
        }
      },
      "32": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 229,
          column: 54
        }
      },
      "33": {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 235,
          column: 7
        }
      },
      "34": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 245,
          column: 7
        }
      },
      "35": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 37
        }
      },
      "36": {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 250,
          column: 45
        }
      },
      "37": {
        start: {
          line: 253,
          column: 27
        },
        end: {
          line: 257,
          column: 3
        }
      },
      "38": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 256,
          column: 5
        }
      },
      "39": {
        start: {
          line: 255,
          column: 6
        },
        end: {
          line: 255,
          column: 25
        }
      },
      "40": {
        start: {
          line: 259,
          column: 32
        },
        end: {
          line: 263,
          column: 3
        }
      },
      "41": {
        start: {
          line: 260,
          column: 4
        },
        end: {
          line: 262,
          column: 5
        }
      },
      "42": {
        start: {
          line: 261,
          column: 6
        },
        end: {
          line: 261,
          column: 36
        }
      },
      "43": {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 270,
          column: 8
        }
      },
      "44": {
        start: {
          line: 271,
          column: 18
        },
        end: {
          line: 271,
          column: 52
        }
      },
      "45": {
        start: {
          line: 272,
          column: 26
        },
        end: {
          line: 272,
          column: 57
        }
      },
      "46": {
        start: {
          line: 273,
          column: 24
        },
        end: {
          line: 273,
          column: 48
        }
      },
      "47": {
        start: {
          line: 274,
          column: 21
        },
        end: {
          line: 274,
          column: 47
        }
      },
      "48": {
        start: {
          line: 275,
          column: 32
        },
        end: {
          line: 275,
          column: 62
        }
      },
      "49": {
        start: {
          line: 278,
          column: 6
        },
        end: {
          line: 278,
          column: 92
        }
      },
      "50": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 326,
          column: 5
        }
      },
      "51": {
        start: {
          line: 280,
          column: 6
        },
        end: {
          line: 325,
          column: 8
        }
      },
      "52": {
        start: {
          line: 286,
          column: 27
        },
        end: {
          line: 286,
          column: 45
        }
      },
      "53": {
        start: {
          line: 287,
          column: 26
        },
        end: {
          line: 287,
          column: 56
        }
      },
      "54": {
        start: {
          line: 300,
          column: 16
        },
        end: {
          line: 320,
          column: 40
        }
      },
      "55": {
        start: {
          line: 301,
          column: 33
        },
        end: {
          line: 301,
          column: 62
        }
      },
      "56": {
        start: {
          line: 302,
          column: 32
        },
        end: {
          line: 302,
          column: 77
        }
      },
      "57": {
        start: {
          line: 311,
          column: 37
        },
        end: {
          line: 311,
          column: 66
        }
      },
      "58": {
        start: {
          line: 327,
          column: 4
        },
        end: {
          line: 345,
          column: 6
        }
      },
      "59": {
        start: {
          line: 330,
          column: 10
        },
        end: {
          line: 342,
          column: 34
        }
      },
      "60": {
        start: {
          line: 330,
          column: 48
        },
        end: {
          line: 330,
          column: 77
        }
      },
      "61": {
        start: {
          line: 349,
          column: 0
        },
        end: {
          line: 351,
          column: 2
        }
      },
      "62": {
        start: {
          line: 353,
          column: 0
        },
        end: {
          line: 359,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 43,
            column: 18
          },
          end: {
            line: 43,
            column: 19
          }
        },
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 46,
            column: 33
          }
        },
        line: 44
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 17
          },
          end: {
            line: 53,
            column: 18
          }
        },
        loc: {
          start: {
            line: 53,
            column: 27
          },
          end: {
            line: 53,
            column: 51
          }
        },
        line: 53
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 72,
            column: 17
          },
          end: {
            line: 72,
            column: 18
          }
        },
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 89
          }
        },
        line: 73
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 91,
            column: 17
          },
          end: {
            line: 91,
            column: 18
          }
        },
        loc: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 87
          }
        },
        line: 92
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 147,
            column: 22
          },
          end: {
            line: 147,
            column: 23
          }
        },
        loc: {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 149,
            column: 17
          }
        },
        line: 148
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        },
        loc: {
          start: {
            line: 152,
            column: 6
          },
          end: {
            line: 152,
            column: 93
          }
        },
        line: 152
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 157,
            column: 39
          },
          end: {
            line: 157,
            column: 40
          }
        },
        loc: {
          start: {
            line: 157,
            column: 48
          },
          end: {
            line: 162,
            column: 5
          }
        },
        line: 157
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        },
        loc: {
          start: {
            line: 166,
            column: 18
          },
          end: {
            line: 166,
            column: 66
          }
        },
        line: 166
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 9
          }
        },
        loc: {
          start: {
            line: 167,
            column: 18
          },
          end: {
            line: 167,
            column: 48
          }
        },
        line: 167
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        },
        loc: {
          start: {
            line: 190,
            column: 14
          },
          end: {
            line: 190,
            column: 52
          }
        },
        line: 190
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 210,
            column: 2
          },
          end: {
            line: 210,
            column: 3
          }
        },
        loc: {
          start: {
            line: 210,
            column: 21
          },
          end: {
            line: 218,
            column: 3
          }
        },
        line: 210
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 220,
            column: 2
          },
          end: {
            line: 220,
            column: 3
          }
        },
        loc: {
          start: {
            line: 220,
            column: 22
          },
          end: {
            line: 222,
            column: 3
          }
        },
        line: 220
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 224,
            column: 2
          },
          end: {
            line: 224,
            column: 3
          }
        },
        loc: {
          start: {
            line: 224,
            column: 25
          },
          end: {
            line: 226,
            column: 3
          }
        },
        line: 224
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 228,
            column: 2
          },
          end: {
            line: 228,
            column: 3
          }
        },
        loc: {
          start: {
            line: 228,
            column: 27
          },
          end: {
            line: 230,
            column: 3
          }
        },
        line: 228
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 232,
            column: 2
          },
          end: {
            line: 232,
            column: 3
          }
        },
        loc: {
          start: {
            line: 232,
            column: 23
          },
          end: {
            line: 236,
            column: 3
          }
        },
        line: 232
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 242,
            column: 2
          },
          end: {
            line: 242,
            column: 3
          }
        },
        loc: {
          start: {
            line: 242,
            column: 26
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 242
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 249,
            column: 2
          },
          end: {
            line: 249,
            column: 3
          }
        },
        loc: {
          start: {
            line: 249,
            column: 16
          },
          end: {
            line: 251,
            column: 3
          }
        },
        line: 249
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 253,
            column: 27
          },
          end: {
            line: 253,
            column: 28
          }
        },
        loc: {
          start: {
            line: 253,
            column: 32
          },
          end: {
            line: 257,
            column: 3
          }
        },
        line: 253
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 259,
            column: 32
          },
          end: {
            line: 259,
            column: 33
          }
        },
        loc: {
          start: {
            line: 259,
            column: 49
          },
          end: {
            line: 263,
            column: 3
          }
        },
        line: 259
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 265,
            column: 2
          },
          end: {
            line: 265,
            column: 3
          }
        },
        loc: {
          start: {
            line: 265,
            column: 11
          },
          end: {
            line: 346,
            column: 3
          }
        },
        line: 265
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 286,
            column: 21
          },
          end: {
            line: 286,
            column: 22
          }
        },
        loc: {
          start: {
            line: 286,
            column: 27
          },
          end: {
            line: 286,
            column: 45
          }
        },
        line: 286
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 287,
            column: 21
          },
          end: {
            line: 287,
            column: 22
          }
        },
        loc: {
          start: {
            line: 287,
            column: 26
          },
          end: {
            line: 287,
            column: 56
          }
        },
        line: 287
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 299,
            column: 29
          },
          end: {
            line: 299,
            column: 30
          }
        },
        loc: {
          start: {
            line: 300,
            column: 16
          },
          end: {
            line: 320,
            column: 40
          }
        },
        line: 300
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 301,
            column: 27
          },
          end: {
            line: 301,
            column: 28
          }
        },
        loc: {
          start: {
            line: 301,
            column: 33
          },
          end: {
            line: 301,
            column: 62
          }
        },
        line: 301
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 302,
            column: 27
          },
          end: {
            line: 302,
            column: 28
          }
        },
        loc: {
          start: {
            line: 302,
            column: 32
          },
          end: {
            line: 302,
            column: 77
          }
        },
        line: 302
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 311,
            column: 31
          },
          end: {
            line: 311,
            column: 32
          }
        },
        loc: {
          start: {
            line: 311,
            column: 37
          },
          end: {
            line: 311,
            column: 66
          }
        },
        line: 311
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 329,
            column: 23
          },
          end: {
            line: 329,
            column: 24
          }
        },
        loc: {
          start: {
            line: 330,
            column: 10
          },
          end: {
            line: 342,
            column: 34
          }
        },
        line: 330
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 330,
            column: 42
          },
          end: {
            line: 330,
            column: 43
          }
        },
        loc: {
          start: {
            line: 330,
            column: 48
          },
          end: {
            line: 330,
            column: 77
          }
        },
        line: 330
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 46,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 3
          },
          end: {
            line: 44,
            column: 14
          }
        }, {
          start: {
            line: 44,
            column: 19
          },
          end: {
            line: 44,
            column: 47
          }
        }, {
          start: {
            line: 44,
            column: 51
          },
          end: {
            line: 44,
            column: 89
          }
        }, {
          start: {
            line: 45,
            column: 3
          },
          end: {
            line: 45,
            column: 19
          }
        }, {
          start: {
            line: 45,
            column: 23
          },
          end: {
            line: 45,
            column: 45
          }
        }, {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 33
          }
        }],
        line: 44
      },
      "1": {
        loc: {
          start: {
            line: 53,
            column: 27
          },
          end: {
            line: 53,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 53,
            column: 42
          },
          end: {
            line: 53,
            column: 45
          }
        }, {
          start: {
            line: 53,
            column: 48
          },
          end: {
            line: 53,
            column: 51
          }
        }],
        line: 53
      },
      "2": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 19
          },
          end: {
            line: 73,
            column: 51
          }
        }, {
          start: {
            line: 73,
            column: 54
          },
          end: {
            line: 73,
            column: 89
          }
        }],
        line: 73
      },
      "3": {
        loc: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 17
          },
          end: {
            line: 92,
            column: 49
          }
        }, {
          start: {
            line: 92,
            column: 52
          },
          end: {
            line: 92,
            column: 87
          }
        }],
        line: 92
      },
      "4": {
        loc: {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 149,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 148,
            column: 5
          },
          end: {
            line: 148,
            column: 16
          }
        }, {
          start: {
            line: 148,
            column: 20
          },
          end: {
            line: 148,
            column: 48
          }
        }, {
          start: {
            line: 148,
            column: 52
          },
          end: {
            line: 148,
            column: 96
          }
        }, {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 17
          }
        }],
        line: 148
      },
      "5": {
        loc: {
          start: {
            line: 152,
            column: 6
          },
          end: {
            line: 152,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 152,
            column: 6
          },
          end: {
            line: 152,
            column: 17
          }
        }, {
          start: {
            line: 152,
            column: 21
          },
          end: {
            line: 152,
            column: 49
          }
        }, {
          start: {
            line: 152,
            column: 53
          },
          end: {
            line: 152,
            column: 93
          }
        }],
        line: 152
      },
      "6": {
        loc: {
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 158
      },
      "7": {
        loc: {
          start: {
            line: 161,
            column: 13
          },
          end: {
            line: 161,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 161,
            column: 40
          },
          end: {
            line: 161,
            column: 45
          }
        }, {
          start: {
            line: 161,
            column: 48
          },
          end: {
            line: 161,
            column: 54
          }
        }],
        line: 161
      },
      "8": {
        loc: {
          start: {
            line: 166,
            column: 18
          },
          end: {
            line: 166,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 166,
            column: 57
          },
          end: {
            line: 166,
            column: 60
          }
        }, {
          start: {
            line: 166,
            column: 63
          },
          end: {
            line: 166,
            column: 66
          }
        }],
        line: 166
      },
      "9": {
        loc: {
          start: {
            line: 166,
            column: 18
          },
          end: {
            line: 166,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 166,
            column: 18
          },
          end: {
            line: 166,
            column: 35
          }
        }, {
          start: {
            line: 166,
            column: 39
          },
          end: {
            line: 166,
            column: 54
          }
        }],
        line: 166
      },
      "10": {
        loc: {
          start: {
            line: 167,
            column: 18
          },
          end: {
            line: 167,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 167,
            column: 35
          },
          end: {
            line: 167,
            column: 40
          }
        }, {
          start: {
            line: 167,
            column: 43
          },
          end: {
            line: 167,
            column: 48
          }
        }],
        line: 167
      },
      "11": {
        loc: {
          start: {
            line: 190,
            column: 14
          },
          end: {
            line: 190,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 31
          },
          end: {
            line: 190,
            column: 47
          }
        }, {
          start: {
            line: 190,
            column: 50
          },
          end: {
            line: 190,
            column: 52
          }
        }],
        line: 190
      },
      "12": {
        loc: {
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 256,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 256,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 254
      },
      "13": {
        loc: {
          start: {
            line: 260,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 260,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 260
      },
      "14": {
        loc: {
          start: {
            line: 268,
            column: 6
          },
          end: {
            line: 270,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 268,
            column: 7
          },
          end: {
            line: 268,
            column: 24
          }
        }, {
          start: {
            line: 268,
            column: 28
          },
          end: {
            line: 268,
            column: 55
          }
        }, {
          start: {
            line: 269,
            column: 7
          },
          end: {
            line: 269,
            column: 24
          }
        }, {
          start: {
            line: 269,
            column: 28
          },
          end: {
            line: 269,
            column: 52
          }
        }, {
          start: {
            line: 269,
            column: 56
          },
          end: {
            line: 269,
            column: 90
          }
        }, {
          start: {
            line: 270,
            column: 6
          },
          end: {
            line: 270,
            column: 8
          }
        }],
        line: 268
      },
      "15": {
        loc: {
          start: {
            line: 278,
            column: 6
          },
          end: {
            line: 278,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 278,
            column: 6
          },
          end: {
            line: 278,
            column: 23
          }
        }, {
          start: {
            line: 278,
            column: 28
          },
          end: {
            line: 278,
            column: 61
          }
        }, {
          start: {
            line: 278,
            column: 65
          },
          end: {
            line: 278,
            column: 91
          }
        }],
        line: 278
      },
      "16": {
        loc: {
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 326,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 326,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 279
      },
      "17": {
        loc: {
          start: {
            line: 279,
            column: 8
          },
          end: {
            line: 279,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 279,
            column: 8
          },
          end: {
            line: 279,
            column: 28
          }
        }, {
          start: {
            line: 279,
            column: 32
          },
          end: {
            line: 279,
            column: 61
          }
        }],
        line: 279
      },
      "18": {
        loc: {
          start: {
            line: 289,
            column: 17
          },
          end: {
            line: 289,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 289,
            column: 17
          },
          end: {
            line: 289,
            column: 32
          }
        }, {
          start: {
            line: 289,
            column: 36
          },
          end: {
            line: 289,
            column: 77
          }
        }],
        line: 289
      },
      "19": {
        loc: {
          start: {
            line: 292,
            column: 13
          },
          end: {
            line: 292,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 292,
            column: 13
          },
          end: {
            line: 292,
            column: 24
          }
        }, {
          start: {
            line: 292,
            column: 28
          },
          end: {
            line: 292,
            column: 68
          }
        }],
        line: 292
      },
      "20": {
        loc: {
          start: {
            line: 293,
            column: 13
          },
          end: {
            line: 293,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 293,
            column: 13
          },
          end: {
            line: 293,
            column: 22
          }
        }, {
          start: {
            line: 293,
            column: 26
          },
          end: {
            line: 293,
            column: 77
          }
        }],
        line: 293
      },
      "21": {
        loc: {
          start: {
            line: 297,
            column: 11
          },
          end: {
            line: 323,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 297,
            column: 11
          },
          end: {
            line: 297,
            column: 26
          }
        }, {
          start: {
            line: 298,
            column: 12
          },
          end: {
            line: 322,
            column: 27
          }
        }],
        line: 297
      },
      "22": {
        loc: {
          start: {
            line: 303,
            column: 19
          },
          end: {
            line: 303,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 303,
            column: 19
          },
          end: {
            line: 303,
            column: 30
          }
        }, {
          start: {
            line: 303,
            column: 34
          },
          end: {
            line: 303,
            column: 96
          }
        }],
        line: 303
      },
      "23": {
        loc: {
          start: {
            line: 304,
            column: 19
          },
          end: {
            line: 319,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 19
          },
          end: {
            line: 304,
            column: 28
          }
        }, {
          start: {
            line: 305,
            column: 20
          },
          end: {
            line: 318,
            column: 39
          }
        }],
        line: 304
      },
      "24": {
        loc: {
          start: {
            line: 313,
            column: 23
          },
          end: {
            line: 316,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 313,
            column: 23
          },
          end: {
            line: 313,
            column: 42
          }
        }, {
          start: {
            line: 314,
            column: 22
          },
          end: {
            line: 316,
            column: 53
          }
        }],
        line: 313
      },
      "25": {
        loc: {
          start: {
            line: 317,
            column: 29
          },
          end: {
            line: 317,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 317,
            column: 74
          },
          end: {
            line: 317,
            column: 93
          }
        }, {
          start: {
            line: 317,
            column: 96
          },
          end: {
            line: 317,
            column: 104
          }
        }],
        line: 317
      },
      "26": {
        loc: {
          start: {
            line: 317,
            column: 29
          },
          end: {
            line: 317,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 317,
            column: 29
          },
          end: {
            line: 317,
            column: 48
          }
        }, {
          start: {
            line: 317,
            column: 52
          },
          end: {
            line: 317,
            column: 72
          }
        }],
        line: 317
      },
      "27": {
        loc: {
          start: {
            line: 331,
            column: 13
          },
          end: {
            line: 331,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 331,
            column: 13
          },
          end: {
            line: 331,
            column: 24
          }
        }, {
          start: {
            line: 331,
            column: 28
          },
          end: {
            line: 331,
            column: 90
          }
        }],
        line: 331
      },
      "28": {
        loc: {
          start: {
            line: 332,
            column: 13
          },
          end: {
            line: 341,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 13
          },
          end: {
            line: 332,
            column: 22
          }
        }, {
          start: {
            line: 333,
            column: 14
          },
          end: {
            line: 340,
            column: 31
          }
        }],
        line: 332
      },
      "29": {
        loc: {
          start: {
            line: 339,
            column: 17
          },
          end: {
            line: 339,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 339,
            column: 62
          },
          end: {
            line: 339,
            column: 81
          }
        }, {
          start: {
            line: 339,
            column: 84
          },
          end: {
            line: 339,
            column: 92
          }
        }],
        line: 339
      },
      "30": {
        loc: {
          start: {
            line: 339,
            column: 17
          },
          end: {
            line: 339,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 339,
            column: 17
          },
          end: {
            line: 339,
            column: 36
          }
        }, {
          start: {
            line: 339,
            column: 40
          },
          end: {
            line: 339,
            column: 60
          }
        }],
        line: 339
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0, 0, 0, 0],
      "15": [0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9d25070d1185bee9464a3f1d045aca6e1898e7ad"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2jwyqr2iz1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2jwyqr2iz1();
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var LANGUAGES = exports.LANGUAGES = (cov_2jwyqr2iz1().s[0]++, {
  en: 'English',
  fr: 'Fran\xE7ais',
  de: 'Deutsch',
  es: 'Espa\xF1ol',
  ca: 'Catal\xE0',
  it: 'Italiano',
  pl: 'Polski',
  ru: 'Русский',
  nl: 'Nederlands',
  sv: 'Svenska',
  fi: 'Finnish',
  ja: '日本語',
  uk: "Y\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
  el: 'Ελληνικά',
  cs: "\u010Desky",
  pt: 'Portugu\xEAs',
  hu: 'Magyar',
  sk: "Sloven\u010Dina",
  sl: 'Slovene',
  lt: 'Lithuanian',
  jh: 'Hiragana',
  jk: 'Katakana',
  zh: 'Chinese',
  eu: 'Euskara'
});
var LANGUAGE_LIST_ID = (cov_2jwyqr2iz1().s[1]++, 'stx-LanguageList');

/** function to get the language color based on the theme */
cov_2jwyqr2iz1().s[2]++;
var langColor = function langColor(props) {
  cov_2jwyqr2iz1().f[0]++;
  cov_2jwyqr2iz1().s[3]++;
  return (cov_2jwyqr2iz1().b[0][0]++, props.theme) && (cov_2jwyqr2iz1().b[0][1]++, props.theme.languageSelector) && (cov_2jwyqr2iz1().b[0][2]++, props.theme.languageSelector.textColor) || (cov_2jwyqr2iz1().b[0][3]++, props.theme.link) && (cov_2jwyqr2iz1().b[0][4]++, props.theme.link.color) || (cov_2jwyqr2iz1().b[0][5]++, _stylingConstants.default.color.baseText);
};
var LanguageButton = (cov_2jwyqr2iz1().s[4]++, (0, _styledComponents.default)(_button.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: 0;\n\n  color: ", ";\n\n  font-weight: ", ";\n\n  &:focus,\n  &:active,\n  &:hover {\n    color: ", ";\n  }\n"])), langColor, function (props) {
  cov_2jwyqr2iz1().f[1]++;
  cov_2jwyqr2iz1().s[5]++;
  return props.active ? (cov_2jwyqr2iz1().b[1][0]++, 600) : (cov_2jwyqr2iz1().b[1][1]++, 400);
}, langColor));
var LanguageListItem = (cov_2jwyqr2iz1().s[6]++, _styledComponents.default.a.attrs({
  className: 'stx-LanguageListItem'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  @media (min-width: 45em) {\n    display: inline-block;\n  }\n  padding-left: ", ";\n  color: ", ";\n  cursor: pointer;\n  font-size: ", ";\n  font-weight: ", ";\n  &:hover {\n    text-decoration: underline;\n  }\n  text-align: center;\n  text-decoration: none;\n"])), _stylingConstants.default.spacing.small, langColor, _stylingConstants.default.font.sizeMS, function (props) {
  cov_2jwyqr2iz1().f[2]++;
  cov_2jwyqr2iz1().s[7]++;
  return props.active ? (cov_2jwyqr2iz1().b[2][0]++, _stylingConstants.default.font.weightBold) : (cov_2jwyqr2iz1().b[2][1]++, _stylingConstants.default.font.weightRegular);
}));
var CurrentLanguageItem = (cov_2jwyqr2iz1().s[8]++, _styledComponents.default.span.attrs({
  className: 'stx-CurrentLanguageItem'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  @media (min-width: 45em) {\n    display: inline-block;\n  }\n  padding-left: ", ";\n  color: ", ";\n  cursor: pointer;\n  font-size: ", ";\n  font-weight: ", ";\n  &:hover {\n    text-decoration: underline;\n  }\n  text-align: center;\n  text-decoration: none;\n"])), _stylingConstants.default.spacing.small, langColor, _stylingConstants.default.font.sizeMS, function (props) {
  cov_2jwyqr2iz1().f[3]++;
  cov_2jwyqr2iz1().s[9]++;
  return props.active ? (cov_2jwyqr2iz1().b[3][0]++, _stylingConstants.default.font.weightBold) : (cov_2jwyqr2iz1().b[3][1]++, _stylingConstants.default.font.weightRegular);
}));
var LanguageSelectionTrigger = (cov_2jwyqr2iz1().s[10]++, _styledComponents.default.a.attrs({
  className: 'stx-LanguageSelectionTrigger',
  tabIndex: "0",
  role: 'link'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  font-size: ", ";\n  font-weight: 600;\n  color: '", "';\n  white-space: nowrap;\n  &:focus,\n  &:active,\n  &:hover {\n    color: ", void 0], ["\n  display: inline-block;\n  font-size: ", ";\n  font-weight: 600;\n  color: '", "';\n  white-space: nowrap;\n  &:focus,\n  &:active,\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n  & span.icon-down {\n    border-top: 8px dashed;\n    border-top: 8px solid\\9;\n    border-right: 4px solid transparent;\n    border-left: 4px solid transparent;\n    cursor: pointer;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    margin-left: 0.5rem;\n    color: #b4b4b4;\n    @media screen and (-ms-high-contrast: active), (forced-colors: active) {\n      -ms-high-contrast-adjust: none;\n      forced-color-adjust: none;\n      background-color: white !important;\n    }\n  }\n"])), _stylingConstants.default.font.sizeM, langColor, langColor));
var LanguageContainer = (cov_2jwyqr2iz1().s[11]++, _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  position: relative;\n  margin: 0 auto;\n"]))));
var LanguageList = (cov_2jwyqr2iz1().s[12]++, _styledComponents.default.ul.attrs({
  id: LANGUAGE_LIST_ID,
  className: 'stx-LanguageList'
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  display: grid;\n  padding: 0.3em;\n\n  @media (min-width: 45em) {\n    grid-template-columns: repeat(3, ", ");\n  }\n  @media (max-width: 30em) {\n    grid-template-columns: repeat(\n      ", ",\n      ", "\n    );\n  }\n\n  z-index: 1;\n  right: 0;\n  align-items: center;\n"])), function (props) {
  cov_2jwyqr2iz1().f[4]++;
  cov_2jwyqr2iz1().s[13]++;
  return (cov_2jwyqr2iz1().b[4][0]++, props.theme) && (cov_2jwyqr2iz1().b[4][1]++, props.theme.languageSelector) && (cov_2jwyqr2iz1().b[4][2]++, props.theme.languageSelector.backgroundColor) || (cov_2jwyqr2iz1().b[4][3]++, 'transparent');
}, function (props) {
  cov_2jwyqr2iz1().f[5]++;
  cov_2jwyqr2iz1().s[14]++;
  return (cov_2jwyqr2iz1().b[5][0]++, props.theme) && (cov_2jwyqr2iz1().b[5][1]++, props.theme.languageSelector) && (cov_2jwyqr2iz1().b[5][2]++, props.theme.languageSelector.borderColor);
}, function (props) {
  cov_2jwyqr2iz1().f[6]++;
  cov_2jwyqr2iz1().s[15]++;
  if (props.flagOnly) {
    cov_2jwyqr2iz1().b[6][0]++;
    cov_2jwyqr2iz1().s[16]++;
    return '5em';
  } else {
    cov_2jwyqr2iz1().b[6][1]++;
  }
  cov_2jwyqr2iz1().s[17]++;
  return props.displayLanguageCode ? (cov_2jwyqr2iz1().b[7][0]++, '6em') : (cov_2jwyqr2iz1().b[7][1]++, '10em');
}, function (props) {
  cov_2jwyqr2iz1().f[7]++;
  cov_2jwyqr2iz1().s[18]++;
  return (cov_2jwyqr2iz1().b[9][0]++, props.displayFlag) && (cov_2jwyqr2iz1().b[9][1]++, !props.flagOnly) ? (cov_2jwyqr2iz1().b[8][0]++, '1') : (cov_2jwyqr2iz1().b[8][1]++, '2');
}, function (props) {
  cov_2jwyqr2iz1().f[8]++;
  cov_2jwyqr2iz1().s[19]++;
  return props.flagOnly ? (cov_2jwyqr2iz1().b[10][0]++, '5em') : (cov_2jwyqr2iz1().b[10][1]++, '9em');
}));
var LanguageWrapper = (cov_2jwyqr2iz1().s[20]++, _styledComponents.default.ul(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n"]))));
var LanguageFlagContainer = (cov_2jwyqr2iz1().s[21]++, _styledComponents.default.li.attrs({
  className: 'stx-LanguageFlagContainer'
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  margin: ", ";\n"])), _stylingConstants.default.spacing.xsmall));
var FlagIcon = (cov_2jwyqr2iz1().s[22]++, (0, _styledComponents.default)(_icon.default).attrs({
  className: 'stx-flagIcon'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  margin: 0 auto;\n  cursor: pointer;\n"])), function (props) {
  cov_2jwyqr2iz1().f[9]++;
  cov_2jwyqr2iz1().s[23]++;
  return props.flagOnly ? (cov_2jwyqr2iz1().b[11][0]++, 'display: flex;') : (cov_2jwyqr2iz1().b[11][1]++, '');
}));
var AccessibilityCurrentLanguage = (cov_2jwyqr2iz1().s[24]++, _styledComponents.default.span.attrs({
  className: 'accessibility-visually-hidden'
})(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"]))));
var KEY_CODE = (cov_2jwyqr2iz1().s[25]++, {
  ENTER: 13
});
var LanguageSelector = exports.LanguageSelector = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(LanguageSelector, _PureComponent);
  var _super = _createSuper(LanguageSelector);
  function LanguageSelector(props) {
    var _this;
    (0, _classCallCheck2.default)(this, LanguageSelector);
    cov_2jwyqr2iz1().f[10]++;
    cov_2jwyqr2iz1().s[26]++;
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "languageMenuKeyHandler", (cov_2jwyqr2iz1().s[37]++, function (e) {
      cov_2jwyqr2iz1().f[17]++;
      cov_2jwyqr2iz1().s[38]++;
      if (e.keyCode === KEY_CODE.ENTER) {
        cov_2jwyqr2iz1().b[12][0]++;
        cov_2jwyqr2iz1().s[39]++;
        _this.handleClick();
      } else {
        cov_2jwyqr2iz1().b[12][1]++;
      }
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "languageSelectionKeyHandler", (cov_2jwyqr2iz1().s[40]++, function (e, language) {
      cov_2jwyqr2iz1().f[18]++;
      cov_2jwyqr2iz1().s[41]++;
      if (e.keyCode === KEY_CODE.ENTER) {
        cov_2jwyqr2iz1().b[13][0]++;
        cov_2jwyqr2iz1().s[42]++;
        _this.changeLanguage(language);
      } else {
        cov_2jwyqr2iz1().b[13][1]++;
      }
    }));
    cov_2jwyqr2iz1().s[27]++;
    _this.state = {
      open: false,
      screenWidth: window.innerWidth
    };
    cov_2jwyqr2iz1().s[28]++;
    _this.changeLanguage = _this.changeLanguage.bind((0, _assertThisInitialized2.default)(_this));
    cov_2jwyqr2iz1().s[29]++;
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(LanguageSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2jwyqr2iz1().f[11]++;
      cov_2jwyqr2iz1().s[30]++;
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2jwyqr2iz1().f[12]++;
      cov_2jwyqr2iz1().s[31]++;
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "updateWindowDimensions",
    value: function updateWindowDimensions() {
      cov_2jwyqr2iz1().f[13]++;
      cov_2jwyqr2iz1().s[32]++;
      this.setState({
        screenWidth: window.innerWidth
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      cov_2jwyqr2iz1().f[14]++;
      cov_2jwyqr2iz1().s[33]++;
      this.setState({
        open: false
      });
    }

    /**
     *
     * In case of change language, change language and close language selector
     */
  }, {
    key: "changeLanguage",
    value: function changeLanguage(newLang) {
      cov_2jwyqr2iz1().f[15]++;
      cov_2jwyqr2iz1().s[34]++;
      this.setState({
        open: false
      });
      cov_2jwyqr2iz1().s[35]++;
      this.props.changeLocale(newLang);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      cov_2jwyqr2iz1().f[16]++;
      cov_2jwyqr2iz1().s[36]++;
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_2jwyqr2iz1().f[19]++;
      // TODO : backward comptabile for the ticket-shop project, to be removed and simplified after whymper v3
      var languages = (cov_2jwyqr2iz1().s[43]++, (cov_2jwyqr2iz1().b[14][0]++, this.props.config) && (cov_2jwyqr2iz1().b[14][1]++, this.props.config.languages) || (cov_2jwyqr2iz1().b[14][2]++, this.props.config) && (cov_2jwyqr2iz1().b[14][3]++, this.props.config.config) && (cov_2jwyqr2iz1().b[14][4]++, this.props.config.config.languages) || (cov_2jwyqr2iz1().b[14][5]++, []));
      var style = (cov_2jwyqr2iz1().s[44]++, this.props.config.style.properties);
      var languageStyle = (cov_2jwyqr2iz1().s[45]++, (0, _get.default)(style, 'languageStyle', ''));
      var displayFlag = (cov_2jwyqr2iz1().s[46]++, languageStyle !== 'text');
      var flagOnly = (cov_2jwyqr2iz1().s[47]++, languageStyle === 'images');
      var displayLanguageCode = (cov_2jwyqr2iz1().s[48]++, this.props.displayLanguageCode);
      var locale = (cov_2jwyqr2iz1().s[49]++, (cov_2jwyqr2iz1().b[15][0]++, this.props.config) && ((cov_2jwyqr2iz1().b[15][1]++, this.props.config.currentLanguage) || (cov_2jwyqr2iz1().b[15][2]++, this.props.config.language)));
      cov_2jwyqr2iz1().s[50]++;
      if ((cov_2jwyqr2iz1().b[17][0]++, languages.length > 3) || (cov_2jwyqr2iz1().b[17][1]++, this.state.screenWidth <= 760)) {
        cov_2jwyqr2iz1().b[16][0]++;
        cov_2jwyqr2iz1().s[51]++;
        return /*#__PURE__*/_react.default.createElement(LanguageContainer, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 281,
            columnNumber: 9
          }
        }, /*#__PURE__*/_react.default.createElement(LanguageSelectionTrigger, (0, _extends2.default)({
          flat: true,
          small: true,
          active: true,
          onClick: function onClick() {
            cov_2jwyqr2iz1().f[20]++;
            cov_2jwyqr2iz1().s[52]++;
            return _this2.handleClick();
          },
          onKeyUp: function onKeyUp(e) {
            cov_2jwyqr2iz1().f[21]++;
            cov_2jwyqr2iz1().s[53]++;
            return _this2.languageMenuKeyHandler(e);
          },
          "aria-expanded": this.state.open
        }, (cov_2jwyqr2iz1().b[18][0]++, this.state.open) && (cov_2jwyqr2iz1().b[18][1]++, {
          'aria-controls': "".concat(LANGUAGE_LIST_ID)
        }), {
          "aria-label": LANGUAGES[locale],
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 282,
            columnNumber: 11
          }
        }), (cov_2jwyqr2iz1().b[19][0]++, displayFlag) && (cov_2jwyqr2iz1().b[19][1]++, /*#__PURE__*/_react.default.createElement(FlagIcon, {
          iconName: "lang_".concat(locale),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 292,
            columnNumber: 29
          }
        })), (cov_2jwyqr2iz1().b[20][0]++, !flagOnly) && (cov_2jwyqr2iz1().b[20][1]++, /*#__PURE__*/_react.default.createElement(CurrentLanguageItem, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 293,
            columnNumber: 27
          }
        }, locale)), /*#__PURE__*/_react.default.createElement("span", {
          className: "icon-down",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 294,
            columnNumber: 13
          }
        })), (cov_2jwyqr2iz1().b[21][0]++, this.state.open) && (cov_2jwyqr2iz1().b[21][1]++, /*#__PURE__*/_react.default.createElement(LanguageList, {
          flagOnly: flagOnly,
          displayFlag: displayFlag,
          displayLanguageCode: displayLanguageCode,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 298,
            columnNumber: 13
          }
        }, languages.map(function (language) {
          cov_2jwyqr2iz1().f[22]++;
          cov_2jwyqr2iz1().s[54]++;
          return /*#__PURE__*/_react.default.createElement(LanguageFlagContainer, {
            onClick: function onClick() {
              cov_2jwyqr2iz1().f[23]++;
              cov_2jwyqr2iz1().s[55]++;
              return _this2.changeLanguage(language);
            },
            onKeyUp: function onKeyUp(e) {
              cov_2jwyqr2iz1().f[24]++;
              cov_2jwyqr2iz1().s[56]++;
              return _this2.languageSelectionKeyHandler(e, language);
            },
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 300,
              columnNumber: 17
            }
          }, (cov_2jwyqr2iz1().b[22][0]++, displayFlag) && (cov_2jwyqr2iz1().b[22][1]++, /*#__PURE__*/_react.default.createElement(FlagIcon, {
            iconName: "lang_".concat(language),
            flagOnly: flagOnly,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 303,
              columnNumber: 35
            }
          })), (cov_2jwyqr2iz1().b[23][0]++, !flagOnly) && (cov_2jwyqr2iz1().b[23][1]++, /*#__PURE__*/_react.default.createElement(LanguageListItem, {
            href: "#",
            flat: true,
            small: true,
            key: language,
            active: locale === language,
            onClick: function onClick() {
              cov_2jwyqr2iz1().f[25]++;
              cov_2jwyqr2iz1().s[57]++;
              return _this2.changeLanguage(language);
            },
            hrefLang: language,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 305,
              columnNumber: 21
            }
          }, (cov_2jwyqr2iz1().b[24][0]++, locale === language) && (cov_2jwyqr2iz1().b[24][1]++, /*#__PURE__*/_react.default.createElement(AccessibilityCurrentLanguage, {
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 314,
              columnNumber: 23
            }
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
            id: "gravity.accessibility.currentLanguage",
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 315,
              columnNumber: 25
            }
          }))), /*#__PURE__*/_react.default.createElement("span", {
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 317,
              columnNumber: 23
            }
          }, (cov_2jwyqr2iz1().b[26][0]++, LANGUAGES[language]) && (cov_2jwyqr2iz1().b[26][1]++, !displayLanguageCode) ? (cov_2jwyqr2iz1().b[25][0]++, LANGUAGES[language]) : (cov_2jwyqr2iz1().b[25][1]++, language)))));
        }))));
      } else {
        cov_2jwyqr2iz1().b[16][1]++;
      }
      cov_2jwyqr2iz1().s[58]++;
      return /*#__PURE__*/_react.default.createElement(LanguageWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 328,
          columnNumber: 7
        }
      }, languages.map(function (language) {
        cov_2jwyqr2iz1().f[26]++;
        cov_2jwyqr2iz1().s[59]++;
        return /*#__PURE__*/_react.default.createElement(LanguageFlagContainer, {
          onClick: function onClick() {
            cov_2jwyqr2iz1().f[27]++;
            cov_2jwyqr2iz1().s[60]++;
            return _this2.changeLanguage(language);
          },
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 330,
            columnNumber: 11
          }
        }, (cov_2jwyqr2iz1().b[27][0]++, displayFlag) && (cov_2jwyqr2iz1().b[27][1]++, /*#__PURE__*/_react.default.createElement(FlagIcon, {
          iconName: "lang_".concat(language),
          flagOnly: flagOnly,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 331,
            columnNumber: 29
          }
        })), (cov_2jwyqr2iz1().b[28][0]++, !flagOnly) && (cov_2jwyqr2iz1().b[28][1]++, /*#__PURE__*/_react.default.createElement(LanguageButton, {
          className: "stx-LanguageButton",
          flat: true,
          small: true,
          key: language,
          active: locale === language,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 333,
            columnNumber: 15
          }
        }, (cov_2jwyqr2iz1().b[30][0]++, LANGUAGES[language]) && (cov_2jwyqr2iz1().b[30][1]++, !displayLanguageCode) ? (cov_2jwyqr2iz1().b[29][0]++, LANGUAGES[language]) : (cov_2jwyqr2iz1().b[29][1]++, language))));
      }));
    }
  }]);
  return LanguageSelector;
}(_react.PureComponent);
cov_2jwyqr2iz1().s[61]++;
LanguageSelector.defaultProps = {
  displayLanguageCode: true
};
cov_2jwyqr2iz1().s[62]++;
LanguageSelector.propTypes = {
  /** function that will be called on change locale */
  changeLocale: _propTypes.default.func.isRequired,
  /** The list of possible languages */
  config: _config.ConfigType.isRequired,
  displayLanguageCode: _propTypes.default.bool
};
var _default = exports.default = (0, _reactOnclickoutside.default)(LanguageSelector);